import { Box, HStack, Stack, StackDirection, Text } from "@chakra-ui/react";

import { formatQuantityValue } from "util/statHelpers";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import QuantityProgressBar from "./ContractQuantityProgressBar";

type ContractQuantityProgressBarSectionProps = {
  productName: string;
  quantityTotal: number;
  quantityTotalFormatted: string;
  quantityShipped: number;
  quantityShippedFormatted?: string;
  onOrder: number;
  remaining: number;
  uom: string;
};

const stackDirection = mobileStyleBreakpoint<string>(
  "column",
  "row"
) as StackDirection;
const fontWeight = mobileStyleBreakpoint<string>("semibold", "black");
const textStyle = mobileStyleBreakpoint<string>("body", "h4");

const LegendItem = ({
  color,
  text,
  quantity,
  uom,
}: {
  color: string;
  text: string;
  quantity: number;
  uom: string;
}) => (
  <HStack>
    <Box bg={color} boxSize={5} borderRadius="full" />
    <Text color="grey.700" pl={2} fontWeight="semibold">
      {formatQuantityValue(quantity)} {uom}
    </Text>
    <Text color="grey.400">{text}</Text>
  </HStack>
);

const StyledProductInfoText = ({ children }: { children: React.ReactNode }) => (
  <Text color="grey.700" fontWeight={fontWeight} textStyle={textStyle}>
    {children}
  </Text>
);

const ContractQuantityProgressBarSection = ({
  productName,
  quantityTotal,
  quantityTotalFormatted,
  quantityShipped,
  onOrder,
  remaining,
  uom,
}: ContractQuantityProgressBarSectionProps) => (
  <Stack spacing={4}>
    <Stack
      direction={stackDirection}
      spacing={4}
      justifyContent="space-between"
      px={1}
    >
      <StyledProductInfoText>{productName}</StyledProductInfoText>
      <StyledProductInfoText>
        {quantityTotalFormatted} {uom}
      </StyledProductInfoText>
    </Stack>
    <QuantityProgressBar
      quantityTotal={quantityTotal}
      shipped={quantityShipped}
      onOrder={onOrder}
      remaining={remaining}
    />
    <Stack
      direction={stackDirection}
      justifyContent="space-between"
      spacing={3}
    >
      <Stack direction={stackDirection} spacing={3}>
        <LegendItem
          color="navy.700"
          text="Shipped"
          quantity={quantityShipped}
          uom={uom}
        />
        <LegendItem
          color="navy.600"
          text="On Order"
          quantity={onOrder}
          uom={uom}
        />
      </Stack>
      <LegendItem
        color="gray.100"
        text="Remaining"
        quantity={remaining}
        uom={uom}
      />
    </Stack>
  </Stack>
);

export default ContractQuantityProgressBarSection;
